import { render, staticRenderFns } from "./ConfirmPersonalData.vue?vue&type=template&id=64bd8836"
import script from "./ConfirmPersonalData.vue?vue&type=script&lang=ts"
export * from "./ConfirmPersonalData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports